import { render, staticRenderFns } from "./LearnAboutProcess.vue?vue&type=template&id=49912bc6&"
import script from "./LearnAboutProcess.vue?vue&type=script&lang=js&"
export * from "./LearnAboutProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports